import {
  CATALOG_AUTHOR_BOOK_LIST_SET_DATA,
  CATALOG_AUTHOR_BOOK_LIST_RESET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  author: null,
  books: null,
  paginateBy: 24,
  pageNumber: 1,
  lastPageNumber: 0,
  orderBy: 'popular',
  totalBookCount: null,
  subscriptionId: null,
  bookType: null,
};

export default function authorBookList(state = initialState, action) {
  switch (action.type) {
    case CATALOG_AUTHOR_BOOK_LIST_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_AUTHOR_BOOK_LIST_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
